import styled from '@emotion/styled';
import { Button } from '@pairy/pds-react';
import { VIEWER_Z_INDEX } from '@pairy/sheard/constants';

export const ArrowButton = styled(Button)`
  z-index: ${VIEWER_Z_INDEX.mobileLayer};

  width: auto;
  height: auto;

  &.disable {
    cursor: initial;
    opacity: 0.25;
  }

  transition: opacity 0.15s ease-in-out;
`;
